export default
{
    "title": '',
    "endP":"活动已结束",
    "versionLowPlaceholder":"此app版本过低，暂不支持跳转功能，请麻烦到app内查看",
    "versionPlaceholder":"此app版本过低，无法参与活动.请到 我的设置-版本 点击升级",
    "common":{
        "errorText":"未知错误,请稍后重试;",
        "errorMiss":"参数缺失,请稍后重试;",
        "submit": "提交",
        "defaultInput": "请输入",
        "cancel": "取消",
        "confirm": "确认",
        "loginTimeout": "未登录或者登录超时，请重新登录",
        "noData": "没有数据",
        "custom": "在线客服",
    },
    "route": {
        "login": '登陆',
        "dashboard": '首页',
        "introduction": '简述',
        "documentation": '文档',
        "permission": '权限测试页',
        "icons": '图标',
        "components": '组件',
        "componentIndex": '介绍',
        "tinymce": '富文本编辑器',
        "markdown": 'Markdown',
        "jsonEditor": 'JSON编辑器',
        "dndList": '列表拖拽',
        "splitPane": 'Splitpane',
        "avatarUpload": '头像上传',
        "dropzone": 'Dropzone',
        "sticky": 'Sticky',
        "countTo": 'CountTo',
        "componentMixin": '小组件',
        "backToTop": '返回顶部',
        "charts": '图表',
        "keyboardChart": '键盘图表',
        "lineChart": '折线图',
        "mixChart": '混合图表',
        "example": '综合实例',
        "Table": 'Table',
        "dynamicTable": '动态Table',
        "dragTable": '拖拽Table',
        "inlineEditTable": 'Table内编辑',
        "complexTable": '综合Table',
        "treeTable": '树形表格',
        "customTreeTable": '自定义树表',
        "tab": 'Tab',
        "form": '表单',
        "createForm": '创建表单',
        "editForm": '编辑表单',
        "errorPages": '错误页面',
        "page401": '401',
        "page404": '404',
        "errorLog": '错误日志',
        "excel": 'Excel',
        "exportExcel": 'Export Excel',
        "selectExcel": 'Export Selected',
        "uploadExcel": 'Upload Excel',
        "zip": 'Zip',
        "exportZip": 'Export Zip',
        "theme": '换肤',
        "clipboardDemo": 'Clipboard',
        "i18n": '国际化'
    },
    "navbar": {
        "logOut": '退出登录',
        "dashboard": '首页',
        "github": '项目地址',
        "screenfull": '全屏',
        "theme": '换肤'
    },
    "login": {
        "title": '系统登录',
        "logIn": '登录',
        "username": '账号',
        "password": '密码',
        "any": '随便填',
        "thirdparty": '第三方登录',
        "thirdpartyTips": '本地不能模拟，请结合自己业务进行模拟！！！'
    },
    "documentation": {
        "documentation": '文档',
        "github": 'Github 地址'
    },
    "permission": {
        "roles": '你的权限',
        "switchRoles": '切换权限'
    },
    "components": {
        "documentation": '文档',
        "tinymceTips": '富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见',
        "dropzoneTips": '由于我司业务有特殊需求，而且要传七牛 所以没用第三方，选择了自己封装。代码非常的简单，具体代码你可以在这里看到 @/components/Dropzone',
        "stickyTips": '当页面滚动到预设的位置会吸附在顶部',
        "backToTopTips1": '页面滚动到指定位置会在右下角出现返回顶部按钮',
        "backToTopTips2": '可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
        "imageUploadTips": '由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。'
    },
    "table": {
        "dynamicTips1": '固定表头, 按照表头顺序排序',
        "dynamicTips2": '不固定表头, 按照点击顺序排序',
        "dragTips1": '默认顺序',
        "dragTips2": '拖拽后顺序',
        "title": '标题',
        "importance": '重要性',
        "type": '类型',
        "remark": '点评',
        "search": '搜索',
        "add": '添加',
        "export": '导出',
        "reviewer": '审核人',
        "id": '序号',
        "date": '时间',
        "author": '作者',
        "readings": '阅读数',
        "status": '状态',
        "actions": '操作',
        "edit": '编辑',
        "publish": '发布',
        "draft": '草稿',
        "delete": '删除',
        "cancel": '取 消',
        "confirm": '确 定'
    },
    "errorLog": {
        "tips": '请点击右上角bug小图标',
        "description": '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
        "documentation": '文档介绍'
    },
    "excel": {
        "export": '导出',
        "selectedExport": '导出已选择项',
        "placeholder": '请输入文件名(默认excel-list)'
    },
    "zip": {
        "export": '导出',
        "placeholder": '请输入文件名(默认file)'
    },
    "theme": {
        "change": '换肤',
        "documentation": '换肤文档',
        "tips": 'Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。'
    },
    "veritrans": {
        "orderNo": "订单号",
        "cardNum": "银行卡号",
        "cardholderName": "持卡人姓名",
        "inputCard": "请输入银行卡号",
        "inputCardholderName": "请输入持卡人姓名",
        "supportType": "支持类型",
        "expiryDate": "有效日期",
        "csc": "安全码CSC",
        "pay": "支付",
        "paySettle": "支付处理中",
        "payCancel": "支付取消中",
        "payFailed": "支付失败",
        "succeed": "完成支付",
        "fail": "支付遇到问题，重新支付",
        "Cancelpay": "取消支付",
        "repay": "重新支付",
        "contactUs": "联系客服"
    },
    "msgPush": {
        "tips": "温馨提醒",
        "closePush": "关闭后，你可能会错过我们的优惠活动等相关信息",
        "confirm": "确定",
        "cancel": "取消",
        "appPush": "app消息推送",
        "emailPush": "邮件推送",
        "loginFirst": "未登录或登录失效，如需继续操作，请先登录？"
    },
    //paygo---开始
    "title":"GlocalMe",
    "route.Home": "按流量计费",
    "route.rate":"国家或地区费率",
    "route.record":"历史记录",
    "common.nonedata": "暂无数据",
    "common.nonedataRate" : "暂无费率信息",
    "common.more" : "更多",
    "route.home.flowType" : "按流量计费",//
    "route.home.rateTit" : "当前计费地区",
    "route.home.timeUse" : "计费时段",//计费时长
    "route.home.DataUse" : "累计流量",
    "route.home.MoneyUse" : "计费金额",
    "route.home.history" : "查看扣费记录 >",
    "route.home.OtherRate" : "全部费率",//
    "route.home.useMethod" : "使用方法",
    "route.home.addMinutes" : "提前充值",
    "route.home.arrived" : "到达目的地开机使用",
    "route.home.useRule" : "使用规则",
    "route.home.updateTips" : "你尚未升级至放心GO服务",
    "route.home.updateBtn" : "立即升级",
    "route.home.updateBtn2" : "立即升级",
    "route.home.LaterUpdateBtn" : "晚点升级",
    "route.home.updateService" : "升级服务",
    "route.home.updateSuccess" : "升级成功",
    "route.home.country" : "国家",///地区
    "route.home.cost" : "资费",
    "route.home.TopCost" : "封顶",
    "route.home.Success" : "好",
    "route.home.where" : "获取不到位置",
    "route.home.ReLogin":"您已成功升级至放心GO服务！若您账户下有普通包，现已转为叠加包。请返回APP重新登录以刷新服务。温馨提醒您出行前保证余额充足哦。",
    "route.home.ReLoginBtn":"去登陆",
    "route.home.flowTypeDesc":"无套餐可用时按流量计费。费率：{rateCurrency} {rate}/MB。(按流量计费时会临时冻结一部分余额)",
    "route.home.flowTypeDescLimit":"无套餐可用时按流量计费。费率：{rateCurrency} {rate}/MB，封顶金额：{amountCurrency} {amount}(按流量计费时会临时冻结一部分余额)",
    errorCode: {
        '01282001': '登录用户名或密码错误',
        '01282002': '登录用户已停用',
        '01282003': '登录用户名为空',
        '01282004': '登录密码为空',
        '01282501': '代理商不存在',
        '01282503': '代理商已停用',
        '00000008': '登录客户与accessToken不匹配'
    },
    "paygo.basePayFlagMsg.true":"开启成功",
    "paygo.basePayFlagMsg.false":"关闭成功",
    "paygo.QueryFlowHistory.NullData":"暂无数据",
    //paygo---结束
}



// WEBPACK FOOTER //
// ./src/lang/zh.js